export default __webpack_public_path__ + "static/media/tick_icon.c85f7ef4.svg";